import { Box, Paper, Typography } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import TreeRow2 from './TreeRow2';

const TreeTable = ({ data = [], tableConfig = {}, onProjectClick }) => {
  const [expandedIds, setExpandedIds] = useState(new Set());

  useEffect(() => {
    // console.log('TreeTable data', data);

    setExpandedIds(new Set()); // сброс на новое дерево
  }, [data]);

  const columns = tableConfig.columns || [];

  const handleToggle = useCallback((nodeId) => {
    setExpandedIds((prev) => {
      const next = new Set(prev);
      if (next.has(nodeId)) next.delete(nodeId);
      else next.add(nodeId);
      return next;
    });
  }, []);

  if (!data.length) {
    return <Typography>Нет данных за период</Typography>;
  }

  let counter = 0;

  return (
    <>
      <Paper sx={{ p: 0 }}>
        <Box>
          {data.map((node, index) => {
            counter = counter + node?.count || 0;
            return (
              <TreeRow2
                key={`${node.id}-${index}`} // ← Стабильный key!
                node={node}
                level={0}
                columns={columns}
                onToggle={handleToggle}
                onProjectClick={onProjectClick} // ← Новый пропс!
                isExpanded={expandedIds.has(node.id)}
                expandedIds={expandedIds}
              />
            );
          })}
        </Box>
      </Paper>
      <Typography sx={{ p: 2, fontWeight: 600 }}>Итого: {counter}</Typography>
    </>
  );
};

export default TreeTable;
